import { render, staticRenderFns } from "./CompetencesEdit.vue?vue&type=template&id=39a93e70&"
import script from "./CompetencesEdit.vue?vue&type=script&lang=js&"
export * from "./CompetencesEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports